import React from "react";
import { InputAdapter, inputProps } from "./InputAdapter";
import {inputType} from "./inputConstants";

export const PasswordField = (props) => {
    return <InputAdapter {...props} inputType={inputType.PASSWORD}/>;
};

PasswordField.propTypes = {...inputProps};